import Vue from 'vue';
import Store from '@/dealer-locator/store';
// import Router from '@/contact-form/router';
import App from '@/dealer-locator/App';

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#dealer-locator');
  Vue.config.devtools = true;
  Vue.config.productionTip = false;

  const app = new Vue({
    store: new Store().store,
    // router: new Router().router,
    data: () => Object.assign({}, el.dataset),
    render: h => h(App)
  });
  app.$mount(el)
});
